<template>
  <div class="headbox cursorstyle">
    <!--头部-->
    <div class="head">
      <div class="topber">
        <!-- <img src="../../assets/topimg/编组 3.png">
        <img src="../../assets/topimg/编组 6.png"> -->
        <img src="../../assets/homeImg/logo1.png">
        <img src="../../assets/homeImg/logo2.png">
        <img src="../../assets/homeImg/logo3.png">
        <div class="Toggle_buttonbox stylePointer">
          <div v-for="(item,index) in navlist" :key='index' @click="itembtn(index,item)"
               :class="isactive == index ? 'SelectItem' : 'SelectItemHover' ">
            {{ item.title }}
          </div>
          <!-- <div>


          </div> -->

        </div>
        <div class="headPortrait">
          <el-dropdown style="width: 5vw;" @command="handleCommand">
            <!-- <span class="el-dropdown-link">
              下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
            </span> -->
            <div class="headPortraitbox" >
              <div class="bg"></div>
              <div class="bgtext" :title="this.userObj.info().nature ==2?this.userObj.info().company:this.userObj.info().name" style="color: #FFFFFF;margin-left: 5px">
                <span v-if="this.userObj.info().nature ==2"> {{ this.userObj.info().company}}</span>
                <span v-else>{{ this.userObj.info().name }}</span>
              </div>
            </div>
            <el-dropdown-menu slot="dropdown" style="width: 5vw; text-align: center;">
              <el-dropdown-item command="AccountData">账号资料</el-dropdown-item>
              <el-dropdown-item command="ChangePassword">修改密码</el-dropdown-item>
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="topberText" style="display: flex;">
          <div class="topberText1">
            <div :class="this.$route.query.mark == 2?'':'qq'">
              北京中医医院知识产权保护与科技成果转化基地
            </div>
            <div class="text3" v-if="this.$route.query.mark == 2">
              北京首都中医医疗科技开发公司
            </div>
            <div class="" v-else>
              北京中医、中西医结合知识产权保护与成果转化基地
            </div>

          </div>
          <div class="topberText2">
            信息管理平台
          </div>
        </div>
      </div>
      <!--  分割线-->
      <div class="hrbox"></div>
      <div class="imgtu">
        <div class="divclass1">
          专业保护
        </div>
        <div class="divclass2">
          快捷转化
        </div>
        <div class="divclass3">
          信息透明
        </div>
      </div>

      <!-- 搜索 -->
      <div class="head_content">
        <!-- <div class="">
          Intellectual Property Protection Service Center
        </div> -->
        <div class="search">
          <searchTPL></searchTPL>
          <!-- <div class="search_leftbox stylePointer">请输入关键词，例如产权名称、产权代码等</div>
          <div class="search_rightbox stylePointer">搜索</div> -->
        </div>
      </div>
      <!-- 访问量 -->
      <div class="head_content_text arrowstyle">
        <div>
          <div class="text_top">{{ this.datastat.pv }}</div>
          <div class="text_content">累计访问量</div>
        </div>
        <div>
          <div class="text_top">{{ this.datastat.patent_count }}</div>
          <div class="text_content">专利申报总数</div>
        </div>
        <div>
          <div class="text_top">{{ this.datastat.trademark_count }}</div>
          <div class="text_content">商标注册申请总数</div>
        </div>
        <div>
          <div class="text_top">{{ this.datastat.software_count }}</div>
          <div class="text_content">软件著作权申请总数</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchTPL from './searchTPL.vue'
import {
  statInterface
} from '@/api/index.js'
import {
  logoutInt
} from '@/api/index.js'

export default {
  data() {
    return {
      navlist: [{
        title: '首页',
        url: './homepage'
      },
        {
          title: '申请管理',
          url: './ApplicationManagement'
        },
        {
          title: '成果转化',
          url: './Achievements'
        },
        {
          title: '通知公告',
          url: './Notice'
        },
        {
          title: '办事指南',
          url: './Guide'
        },
        {
          title: '相关规范',
          url: './Standard'
        },
        {
          title: '常用表格',
          url: './CommonTables'
        },

      ],
      isactive: 0,
      //统计的数据
      datastat: {},
    }
  },
  components: {searchTPL},
  watch: {
    $route: {
      handler(val, oldval) {
        if (val.name == 'homepage') {
          this.isactive = 0
        } else if (val.name == 'ApplicationManagement') {
          this.isactive = 1
        } else if (val.name == 'Achievements') {
          this.isactive = 2
        } else if (val.name == 'Notice') {
          this.isactive = 3
        } else if (val.name == 'Guide') {
          this.isactive = 4
        } else if (val.name == 'Standard') {
          this.isactive = 5
        } else if (val.name == 'CommonTables') {
          this.isactive = 6
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    let index = sessionStorage.getItem('itemUrl')
    this.isactive = index
    //获取首页统计的数据
    this.statInterfaces()
  },

  methods: {
    itembtn(index, item) {
      //将点击的元素的索引赋值给bian变量
      this.isactive = index
      this.$router.push(item.url)
      sessionStorage.setItem('itemUrl', index)
    },
    async statInterfaces() {
      let res = await statInterface({})
      if (res.code == '00000') {
        this.datastat = res.data
      }
    },
    handleCommand(command) {
      if (command == 'logout') {
        this.logout()
      } else if (command == 'ChangePassword') {
        console.log('ChangePassword')
        this.$router.push('./ChangePassword')

      } else if (command == 'AccountData') {
        this.$router.push('./AccountData')
      }
    },
    async logoutfunction() {
      let res = await logoutInt()
      if (res.code == '00000') {
        this.userObj.logout()
        this.$message({
          type: 'success',
          message: '退出账号成功!'
        });
        this.$router.push('./firstPage')
      } else {
        this.$message({
          type: 'success',
          message: '退出账号失败!'
        });
      }
    },
    // 退出登录
    logout() {
      this.$confirm('确定退出当前账号?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        // this.$message({
        //   type: 'success',
        //   message: '删除成功!'
        // });
        this.logoutfunction()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '退出失败'
        });
      });

    }
  }
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

/*鼠标放上变小手*/
.stylePointer {
  cursor: pointer;
}

.head {
  width: 100%;
  // height: 78vh;
  //height: 42vh;
  height: 24vw;
  background: red;
  background: url("../../assets/img/topbg.png") no-repeat center;
  background-size: 100% 100%;
  overflow: hidden;
  position: relative;
}

.imgtu {
  // position: absolute;
  // right: 11vw;
  // width: 19vw;
  // border: 1px yellow solid;
}

// .box1,
// .box2 {
// 	width: 100px;
// 	height: 100px;
// 	background: red;
// 	margin: 30px 30px;
// 	float: left;

// }

.imgtu div {
  // width: 9.8vw;
  // height: 18vh;
  width: 6vw;
  height: 6vw;

  // background: url("~@/assets/img/位图.png") no-repeat center;
  font-size: 1.12rem;
  // font-weight: bold;
  color: #FFFFFF;
  text-align: center;
  line-height: 9vw;
  float: left;
  transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  margin-top: 3px;
}

.imgtu div.divclass1 {
  position: absolute;
  top: 6vw;
  right: 21vw;
  // border: 1px yellow solid;
  background: url('~@/assets/topimg/10.png') no-repeat center;
  background-size: 100% 100%;
  animation: myfirst 3s;
  -webkit-animation: myfirst 3s;
  /* Safari and Chrome */
}

@keyframes myfirst {
  0% {
    top: -10vh;
    right: 21vw;
  }

  // 55% {
  // 	top: 5vh;
  // 	right: 21vw;
  // }

  100% {
    top: 6vw;
    right: 21vw;
  }
}

/* Safari and Chrome */
@-webkit-keyframes myfirst {
  0% {
    top: -10vh;
    right: 21vw;
  }

  // 55% {
  // 	top: 5vh;
  // 	right: 21vw;
  // }

  100% {
    top: 6vw;
    right: 21vw;
  }
}

//.imgtu div.divclass1:hover {
//	margin-top: -5px;
//
//}

.imgtu div.divclass2 {
  position: absolute;
  top: 9vw;
  right: 12vw;
  background: url("~@/assets/topimg/11.png") no-repeat center;
  background-size: 100% 100%;
  // float: right;
  animation: myfirst2 3s;
  -webkit-animation: myfirst2 3s;

}

@keyframes myfirst2 {
  0% {
    top: 9vw;
    right: -11vw;
  }

  // 55% {
  // 	top: 30vh;
  // 	right: 5vw;
  // }

  100% {
    top: 9vw;
    right: 12vw;
  }
}

/* Safari and Chrome */
@-webkit-keyframes myfirst2 {
  0% {
    top: 9vw;
    right: -11vw;
  }

  // 55% {
  // 	top: 30vh;
  // 	right: 5vw;
  // }

  100% {
    top: 9vw;
    right: 6vw;
  }
}

//.imgtu div.divclass2:hover {
//	margin-top: -5px;
//
//}

.imgtu div.divclass3 {
  position: absolute;
  top: 14vw;
  right: 19vw;
  background: url("~@/assets/topimg/17.png") no-repeat center;
  background-size: 100% 100%;
  animation: myfirst3 3s;
  -webkit-animation: myfirst3 3s;
}

@keyframes myfirst3 {
  0% {
    top: 14vw;
    right: 17vw;
    height: 0;
  }

  // 55% {
  // 	top: 58vh;
  // 	right: 21vw;
  // }

  100% {
    top: 14vw;
    right: 19vw;
  }
}

/* Safari and Chrome */
@-webkit-keyframes myfirst3 {
  0% {
    top: 14vw;
    right: 17vw;
    height: 0;
  }

  100% {
    top: 14vw;
    right: 17vw;
  }
}

//.imgtu div.divclass3:hover {
//	margin-top: -5px;
//
//}

.head_content {
  margin: 0 auto;
  margin-top: 4.6vw;
  // border: 1px green solid;
  width: 63vw;
  // display: flex;
}

.head_content > div:nth-child(1) {
  font-weight: bold;
  color: #FFFFFF;
  font-size: 3.2rem;
  width: 35vw;
}

.head_content > div.title {
  width: 29.6vw;
  height: 5vh;

  img {
    width: 100%;
    height: 100%;
  }
}

.head_content > div.search {
  width: 39vw;
  height: 3.1vw;
  margin-top: 14px;
  // margin-left: 28px;
  display: flex;
}

.search_leftbox {
  width: 33vw;
  line-height: 3.1vw;
  color: rgba(151, 144, 144, 0.58);
  font-size: 1rem;
  background: #ffffff;
  padding-left: 13px;
  border-radius: 5px 0px 0px 5px;
}

.search_rightbox {
  width: 5.6vw;
  height: 3.1vw;

  background: #D96025;
  border-radius: 0px 5px 5px 0px;
  text-align: center;
  line-height: 5vh;
  font-size: 1.12rem;
  color: #ffffff;
}

/*等分4个盒子*/
.head_content_text {
  width: 58vw;
  margin-top: 6vw;
  margin-left: 18.5vw;
  display: flex;
  color: #ffffff;
  height: 23.2vh;

}

.head_content_text > div {
  // width: calc((100% - 75px)/4);
  margin-right: 2.3vw;
}

.head_content_text > div:last-of-type {
  margin-right: 0;
}

.head_content_text > div > .text_top {
  font-size: 2.3rem;

}

.head_content_text > div > .text_content {
  font-size: 1.3rem;
}

.hrbox {
  width: 100%;
  height: 1px;
  background: #E5E5E5;
  // margin-top: 1.5vh;
  opacity: 0.2;
}

.topber {
  display: flex;
  // border: 1px red solid;
  height: 4.7vw;
  width: 98vw;
  margin: 0 auto;
  // margin-top: 3.6vh;
}

.topber img:nth-child(1) {
  margin-left: 3vw;
}

.topber img {
  width: 3vw;
  height: 3vw;
  margin-right: 1vw;
  margin-top: 1vw;
}

.topberText {
  font-size: 1rem;
  color: #FFFFFF;
  margin-left: 4vw;
  margin-top: 0.5vw;
  height: 4vw;

  .topberText1 {
    border-right: #75A096 solid 1px;
    padding-right: 1vw;
    font-weight: bold;

    div {
      margin-top: 1vh;
    }

    .qq {
      letter-spacing: 0.078vw;
    }

    .text3 {
      letter-spacing: 0.45vw;
    }

  }

  .topberText2 {
    margin-left: 1vw;
    line-height: 4vw;
  }
}

/*等分7个盒子*/
.Toggle_buttonbox {
  width: 30vw;
  // border: 1px black solid;
  height: 100%;
  // margin: 0 auto;
  margin-left: 16vw;
  display: flex;
  color: #ffffff;
  justify-content: space-between;
  line-height: 5.5vh;
}

.Toggle_buttonbox > div {
  /*width: calc((100% - 75px)/4);*/
  margin-right: 1vw;
  text-align: center;
  font-size: 1rem;
  line-height: 4.7vw;

}

.SelectItem {
  // border-bottom: 2px #ffffff solid;
  font-weight: bolder;
  color: #F4D590;

}

.SelectItemHover:hover {
  color: #F4D590;
}

// .Toggle_buttonbox>div:last-child {
// 	margin-right: 0px;
// 	/*border: 1px red solid;*/
// 	width: 110px;
// 	margin-right: 0px;
// }

// .Toggle_buttonbox>div:last-child>div {
// 	display: inline-block;
// }
.headPortrait {
  display: flex;
  align-items: center;
}

.headPortrait div.bg {
  width: 2.3vw;
  height: 2.3vw;
  border-radius: 50%;
  background: url("../../assets/img/位图.png") no-repeat center;
  vertical-align: middle;

  div {
    color: #ffffff;
  }
}

.bgtext {
  width: 30px;
  overflow: hidden;
  ///*超出部分隐藏*/
  text-overflow: ellipsis;
  ///* 超出部分显示省略号 */
  white-space: nowrap;
  ///*规定段落中的文本不进行换行 */
}

.headPortrait .headPortraitbox {
  display: flex;
  align-items: center;
}


a {
  text-decoration: none;
  color: #FFFFFF;
}
</style>
